module.exports = __webpack_public_path__ + "img/lirun.1dd4986d.svg";